package ui.screens.section.wishesandgift

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import data.repository.FirebaseInvitationRepo
import kotlinx.coroutines.launch
import models.Wish
import ui.composables.SuccessDialog
import ui.theme.ColorScheme
import ui.theme.txtColor

@Composable
fun WishesSection(
    modifier: Modifier = Modifier,
    name: String = "",
    repo: FirebaseInvitationRepo,
) {
    var showSuccess by remember { mutableStateOf(false) }
    var pendingWish by remember { mutableStateOf<Wish?>(null) }
    var showInput by rememberSaveable { mutableStateOf(true) }
    var isLoading by remember { mutableStateOf(false) }

    // 🔥 Side-effect kirim data
    LaunchedEffect(pendingWish) {
        val wish = pendingWish ?: return@LaunchedEffect

        isLoading = true

        repo.setWishes(wish.name, wish.from, wish.message, wish.isShow)
        repo.setGift(wish.name, wish.gift)

        isLoading = false

        if (wish.gift == "0") {
            showSuccess = true
            pendingWish = null
        } else {
            showInput = false
        }
    }

    Column(
        modifier = modifier
            .padding(24.dp)
            .widthIn(max = 450.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Text(
            text = "Wishes and Gift",
            style = MaterialTheme.typography.titleMedium.copy(
                fontWeight = FontWeight.Bold
            ),
            color = ColorScheme.primary
        )

        Spacer(Modifier.height(16.dp))

        Text(
            text = "Doa restu Anda merupakan karunia yang sangat berarti bagi kami. Sebagai tanda kasih, Anda juga dapat berbagi kebahagiaan melalui ucapan harapan dan doa untuk kami, serta memberikan kado secara cashless bila berkenan.",
            textAlign = TextAlign.Center,
            style = MaterialTheme.typography.titleSmall.copy(
                fontSize = 16.sp
            ),
            color = txtColor
        )

        Spacer(Modifier.height(24.dp))

        when {
            isLoading -> {
                CircularProgressIndicator()
            }

            showInput -> {
                WishInput(name) { wish ->
                    pendingWish = wish
                }
            }

            else -> {
                pendingWish?.let { wish ->
                    WeddingGiftImage(wish) {
                        showInput = true
                        pendingWish = null
                        showSuccess = true
                    }
                }
            }
        }

        Spacer(Modifier.height(24.dp))

        SuccessDialog(
            show = showSuccess,
            onDismiss = { showSuccess = false }
        )
    }
}